<template>
  <nav aria-label="Fil d'Ariane" class="hidden sm:flex space-x-2 text-sm">
    <router-link
      v-for="(crumb, index) in breadcrumbs"
      :key="index"
      :to="crumb.to"
      class="text-gray-500 hover:text-gray-700 transition-colors duration-200"
      :class="{ 'text-gray-900': index === breadcrumbs.length - 1 }"
    >
      {{ crumb.title }}
      <span v-if="index < breadcrumbs.length - 1" class="mx-2 text-gray-400">/</span>
    </router-link>
  </nav>
</template>

<script setup lang="ts">
interface Breadcrumb {
  title: string
  to: string
}

interface Props {
  breadcrumbs: Breadcrumb[]
}

defineProps<Props>()
</script>
